import { RichUtils } from 'draft-js';

export default () => {
  return {
    customStyleMap: {
      REALTIME_PAST: {
        fontWeight: 'bold',
      },
      REALTIME_NOW: {
        // color: '#ffaa11',
        fontWeight: 'bold',
        background: "#fffe0d",
      }
    },
    // handleKeyCommand: (command, editorState, { setEditorState }) => {
    //   if (command === "style_realtime_past") {
    //     setEditorState(RichUtils.toggleInlineStyle(editorState, "STYLE_REALTIME_PAST"));
    //     return true;
    //   }
    // }
  };
};
